import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../routing/urlsService";
import React from "react";
import OwnershipsPage from "./Ownerships/OwnershipsDashboardModule"


function OwnershipsModule() {

    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.ownerships()} component={OwnershipsPage}/>
            </Switch>
        </Grid>
    )
}


export default OwnershipsModule